export default __webpack_public_path__ + "resources/icons/d600-6f3b.png";